import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { CreateTariffRequest, TariffDto } from '../models/tariff.models';

interface TariffFormDialogData {
  tariff?: TariffDto;
}

@Component({
  selector: 'app-tariff-form-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, TranslatePipe],
  templateUrl: './tariff-form-dialog.component.html',
  styleUrl: './tariff-form-dialog.component.scss',
})
export class TariffFormDialogComponent {
  private readonly fb = inject(FormBuilder);
  private readonly ref = inject(MatDialogRef<TariffFormDialogComponent>);
  private readonly data = inject<TariffFormDialogData>(MAT_DIALOG_DATA);

  readonly isEdit = !!this.data?.tariff;

  readonly form = this.fb.group({
    name: [this.data?.tariff?.name ?? '', [Validators.required, Validators.maxLength(120)]],
    description: [this.data?.tariff?.description ?? ''],
    currency: [
      this.data?.tariff?.currency ?? 'EUR',
      [Validators.required, Validators.minLength(3), Validators.maxLength(3)],
    ],
    priority: [this.data?.tariff?.priority ?? 100, [Validators.required, Validators.min(0)]],
  });

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const v = this.form.getRawValue();
    const request: CreateTariffRequest = {
      name: (v.name ?? '').trim(),
      description: v.description?.trim() ? v.description.trim() : null,
      currency: (v.currency ?? 'EUR').trim().toUpperCase(),
      priority: Number(v.priority ?? 100),
    };
    this.ref.close(request);
  }

  cancel(): void {
    this.ref.close();
  }
}
